import { combineReducers } from 'redux';
import details from './details/reducers';
import list from './list/reducers';

interface IPropertyBookingPageState {
	details: ReturnType<typeof details>;
	list: ReturnType<typeof list>;
}

export default combineReducers<IPropertyBookingPageState>({
	details,
	list
});
